import FormModal from "./FormModal.js";
import FormValidator from "./FormValidator.js";
import FormResponse from "./FormResponse.js";
import { FORM_LANG_MAP } from "./const.js";

const overlay = document.querySelector(".bg-overlay");
const responseSuccess = document.querySelector(".response-success");
const responseFail = document.querySelector(".response-fail");
const triggers = document.querySelectorAll('[data-modal-target="request-form"]');

/**
 * Создаёт экземпляры FormModal, FormValidator, FormResponse для указанного контейнера
 * @param {string} selector - CSS-селектор контейнера формы
 * @returns {{modal: FormModal, validator: FormValidator, response: FormResponse}|null}
 */
function createFormSet(selector) {
  const container = document.querySelector(selector);
  if (!container) {
    return null;
  }

  const modal = new FormModal(
    container,
    triggers,
    overlay,
    responseSuccess,
    responseFail,
  );

  const validator = new FormValidator(container);

  const response = new FormResponse(
    container,
    responseSuccess,
    responseFail,
    modal,
  );

  modal.setFormValidator(validator);
  response.setFormValidator(validator);

  return { modal, validator, response };
}

// Создаём наборы для обоих языков
const forms = {};
for (const [lang, selector] of Object.entries(FORM_LANG_MAP)) {
  forms[lang] = createFormSet(selector);
}

// Определяем текущий язык
let activeLang = document.documentElement.lang === "kk" ? "kk" : "ru";

/**
 * Возвращает активный набор форм
 * @returns {{modal: FormModal, validator: FormValidator, response: FormResponse}|null}
 */
function getActiveFormSet() {
  return forms[activeLang] || forms.ru;
}

// Инициализация валидаторов и ответов для обоих языков
for (const formSet of Object.values(forms)) {
  if (formSet) {
    formSet.validator.init();
    formSet.response.init();
    formSet.modal.initCloseHandlers();
  }
}

// Обработчик триггеров — открывает форму текущего языка
triggers.forEach((trigger) => {
  trigger.addEventListener("click", (event) => {
    const formSet = getActiveFormSet();
    if (formSet) {
      formSet.modal.showForm(event);
    }
  });
});

// MutationObserver на html[lang] для переключения форм при смене языка
const langObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.attributeName !== "lang") {
      continue;
    }

    const newLang = document.documentElement.lang === "kk" ? "kk" : "ru";
    if (newLang === activeLang) {
      return;
    }

    const oldFormSet = forms[activeLang];
    const newFormSet = forms[newLang];

    // Если старая форма открыта — переключаем на новую
    if (oldFormSet?.modal.isOpen && newFormSet) {
      oldFormSet.modal.hideFormOnly();
      newFormSet.modal.showFormOnly();
    }

    activeLang = newLang;
  }
});

langObserver.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ["lang"],
});
